import React, { useContext, useEffect, useState } from "react";
import Hero from "../components/Hero";
import HeaderNav from "../components/HeaderNav";
import Footer from "../components/Footer";
import { Link, Navigate, useNavigate } from "react-router";
import { HiOutlineArrowTurnRightDown } from "react-icons/hi2";
import { MdContentCopy } from "react-icons/md";
import {
  PayPaystack,
  PaystackPaymentConfig,
  ToastError,
  ToastSuccess,
} from "../global/component";
import { ToastContainer } from "react-toastify";
import { BodyText, NormalHeading, SubHeading } from "../global/component";
import { FaRegCircle, FaRegDotCircle } from "react-icons/fa";
import AuthContext from "../global/auth-context";
import { PaystackButton } from "react-paystack";
import { BuyUnitService } from "../models/ApiService";
import CopyToClipboard from "react-copy-to-clipboard";
import { Analytics } from "@vercel/analytics/react";

const BuyUnits = () => {
  const [buyUnit, setBuyUnit] = useState(false);
  const [payOnline, setPayOnline] = useState(false);
  const [payBankTransfer, setPayBankTransfer] = useState(false);
  const [payUSDT, setPayUSDT] = useState(false);
  const [totalUnits, setTotalUnits] = useState(null);
  let navigate = useNavigate();

  let {
    units,
    user,
    userData,
    adminDetails,
    setAmount,
    amount,
    fetchUserData,
    isAuth,
  } = useContext(AuthContext);

  async function PaymentSuccessfull(params) {
    let payload = { user, totalUnits };
    let response = await BuyUnitService(payload);
    if (response.success == true) {
      ToastSuccess(response.message);
      fetchUserData(user);
    } else {
      ToastError(response.message);
    }
  }

  return (
    <>
      <Analytics />
      {!isAuth ? (
        navigate("/login", { replace: true })
      ) : (
        <div className="flex flex-col justify-between h-full">
          <div>
            <HeaderNav page={"units"} />
            <Hero>
              <div className="flex flex-col px-32 py-5 gap-7 h-full justify-center laptop">
                <p className=" text-white font-bold text-5xl ">Buy Your</p>
                <div className="gap-3 flex">
                  <span className=" text-yellow-400 font-bold text-5xl">
                    Conversion Units
                  </span>
                </div>
                <span className=" text-white font-bold text-5xl">Here</span>
                <p className=" text-white font-normal text-xl w-2/3">
                  Users can get conversion units to convert their booking codes
                  from one bookie to another.
                </p>
                <p className=" text-white font-normal text-xl w-2/3">
                  <span className=" text-yellow-500 font-normal text-xl">
                    Note:{" "}
                  </span>{" "}
                  each successful conversion cost 1 unit.
                </p>
              </div>
              <div className="flex flex-col px-5 py-5 gap-7 h-full phone justify-center z-50">
                <div className="flex gap-3 flex-wrap">
                  <span className=" text-white font-bold text-3xl sm:w-full">
                    Buy Your
                  </span>

                  <span className=" text-yellow-400 font-bold text-3xl">
                    Conversion Units
                  </span>
                  <span className=" text-white font-bold text-3xl">Here</span>
                </div>
                <p className=" text-white font-normal text-xl w-2/3">
                  Users can get conversion units to convert their booking codes
                  from one bookie to another.
                </p>
                <p className=" text-white font-normal text-xl w-2/3">
                  <span className=" text-yellow-500 font-normal text-xl">
                    Note:{" "}
                  </span>{" "}
                  each successful conversion cost 1 unit.
                </p>
              </div>
            </Hero>

            {buyUnit == false && (
              <div className="flex py-10 px-5 w-full justify-center bg-myLightGreen items-center gap-3 flex-wrap">
                {units.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className="w-screen h-fit bg-white rounded-2xl border-2 border-myDarkGreen justify-between flex lg:w-96 md:w-96 sm:w-96"
                      style={{
                        boxShadow: 10,
                      }}
                    >
                      <div className="flex self-start w-1/2 p-5 gap-2 flex-col pb-10">
                        <text className="text-lg font-bold text-myNormalGreen">
                          {item.totalUnits} Units
                        </text>

                        <Link
                          onClick={() => {
                            setBuyUnit(true);
                            setPayOnline(true);
                            setTotalUnits(item.totalUnits);
                            setAmount(item.amount);
                          }}
                          className="flex gap-1 items-center bg-myNormalGreen py-2 rounded-2xl w-fit px-5"
                        >
                          <text className="text-sm text-white font-medium text-center ">
                            Purchase
                          </text>
                        </Link>
                      </div>
                      <div
                        className="bg-myNormalGreen w-1/2 flex flex-col pr-5  items-end justify-start pt-5"
                        style={{
                          borderTopLeftRadius: 100,
                          borderTopRightRadius: 10,
                          borderBottomRightRadius: 10,
                        }}
                      >
                        <text className="font-bold text-white text-lg flex-start flex text-start">
                          {item.amount} NGN
                        </text>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {buyUnit && (
              <div className="flex flex-col py-10 px-5 bg-myLightGreen">
                <text className="font-bold text-myNormalGreen text-xl sm:text-2xl lg:text-3xl pb-5">
                  How Would you like to pay?
                </text>
                <div className="flex w-full items-start justify-center flex-col md:flex-row gap-5">
                  <div
                    className={` ${
                      payOnline && "border-2 border-myNormalGreen p-5 bg-white"
                    } w-full md:w-96  items-center justify-center gap-3 flex flex-col `}
                  >
                    <Link
                      onClick={() => {
                        setPayOnline(true);
                        setPayBankTransfer(false);
                        setPayUSDT(false);
                      }}
                      className="flex gap-2  w-full md:w-96  items-center justify-center hover:text-myNormalGreen"
                    >
                      {payOnline == false ? (
                        <FaRegCircle />
                      ) : (
                        <FaRegDotCircle color="#016401" size={30} />
                      )}
                      <text
                        className={`${
                          payOnline && " font-bold"
                        } text-xl md:text-2xl`}
                      >
                        Pay Online
                      </text>
                    </Link>
                    {payOnline && (
                      <div className="flex items-center justify-center flex-col">
                        <text className="text-center">
                          Process payment of the sum of {amount} Naira for{" "}
                          {totalUnits} conversion units Below <br /> <br />
                        </text>
                        <PayPaystack
                          user={user}
                          amount={amount * 100}
                          success={PaymentSuccessfull}
                        />
                      </div>
                    )}
                  </div>
                  <div
                    className={` ${
                      payBankTransfer &&
                      "border-2 border-myNormalGreen p-5 bg-white"
                    } w-full md:w-96  items-center justify-center gap-3 flex flex-col`}
                  >
                    <Link
                      onClick={() => {
                        setPayOnline(false);
                        setPayBankTransfer(true);
                        setPayUSDT(false);
                      }}
                      className="flex gap-2  w-full md:w-96  items-center justify-center hover:text-myNormalGreen"
                    >
                      {payBankTransfer == false ? (
                        <FaRegCircle />
                      ) : (
                        <FaRegDotCircle color="#016401" size={30} />
                      )}
                      <text
                        className={`${
                          payBankTransfer && " font-bold"
                        } text-xl md:text-2xl`}
                      >
                        Manual Payment
                      </text>
                    </Link>
                    {payBankTransfer && (
                      <div className="flex items-center justify-center flex-col">
                        <text className="text-center">
                          Transfer the sum of {amount} Naira for {totalUnits}{" "}
                          conversion units to the account details Below <br />{" "}
                          <br />{" "}
                          <span className="font-bold">
                            {" "}
                            {adminDetails.bank.bankName} <br />
                            <span className="flex gap-2 text-center justify-center">
                              {adminDetails.bank.accountNumber}
                              <CopyToClipboard
                                text={adminDetails.bank.accountNumber}
                              >
                                <Link
                                  onClick={() => {
                                    ToastSuccess("Account Number Copied");
                                  }}
                                  className="flex gap-1 items-center"
                                >
                                  <MdContentCopy color="#016401" />
                                </Link>
                              </CopyToClipboard>{" "}
                            </span>
                            {adminDetails.bank.accountName}
                          </span>
                          <br /> <br /> submit proof of payment below
                        </text>
                        <Link className="flex py-1 bg-myNormalGreen px-3 text-white rounded-md md:text-xl mt-5">
                          Submit Receipt
                        </Link>
                      </div>
                    )}
                  </div>
                  <div className={`w-full md:w-96  flex flex-col`}>
                    {!payUSDT && (
                      <Link
                        onClick={() => {
                          setPayOnline(false);
                          setPayBankTransfer(false);
                          setPayUSDT(true);
                        }}
                        className="flex gap-2  w-full md:w-96  items-center justify-center hover:text-myNormalGreen"
                      >
                        <FaRegCircle />

                        <text className={` text-xl md:text-2xl`}>
                          USDT Payment
                        </text>
                      </Link>
                    )}
                    {payUSDT && (
                      <div
                        className=" flex flex-col bg-white w-full items-center py-5 border-myNormalGreen border-2 
                              px-5
                              "
                      >
                        <div className="flex text-myNormalGreen gap-2 items-center">
                          <FaRegDotCircle size={30} />

                          <text
                            className={`${
                              payUSDT && " font-bold"
                            } text-xl md:text-2xl`}
                          >
                            USDT Payment
                          </text>
                        </div>
                        <text className="text-center text-wrap my-3">
                          Send ${amount / 1000} Naira for {totalUnits}{" "}
                          conversion units to the wallet address Below <br />{" "}
                          <br />
                        </text>
                        <div className="font-bold flex flex-col items-center px-3">
                          <span className=" text-myNormalGreen flex">
                            Wallet Adress:
                          </span>
                          <div className="flex items-center justify-center flex-row text-sm gap-1 sm:text-base">
                            <text className="flex flex-wrap text-wrap self-center">
                              {adminDetails.usdt.walletAddress}
                            </text>
                            <CopyToClipboard
                              text={adminDetails.usdt.walletAddress}
                            >
                              <Link
                                onClick={() => {
                                  ToastSuccess("Address Copied");
                                }}
                                className="flex items-center flex-wrap"
                              >
                                {" "}
                                <MdContentCopy color="#016401" size={20} />
                              </Link>
                            </CopyToClipboard>{" "}
                          </div>
                          <br />
                          <span className=" text-myNormalGreen">
                            {" "}
                            Network: <br />
                          </span>
                          <div className="flex gap-2 text-center justify-center">
                            {adminDetails.usdt.network}
                            <CopyToClipboard text={adminDetails.usdt.network}>
                              <Link
                                onClick={() => {
                                  ToastSuccess("Network Copied");
                                }}
                                className="flex gap-1 items-center "
                              >
                                {" "}
                                <MdContentCopy color="#016401" />
                              </Link>
                            </CopyToClipboard>
                          </div>
                        </div>
                        <text className="text-center text-wrap py-3">
                          submit proof of payment below
                        </text>
                        <Link className="flex py-1 bg-myNormalGreen px-3 text-white rounded-md md:text-xl mt-5">
                          Submit Receipt
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
          <Footer />
        </div>
      )}
    </>
  );
};

export default BuyUnits;
